import routerOptions0 from "/opt/atlassian/pipelines/agent/build/clients/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_52842e05e318ba02b5604df5f08f3b6e/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: true,
  strict: false,
  scrollBehaviorType: "auto"
}
export const hashMode = true
export default {
...configRouterOptions,
...routerOptions0,
}